// extracted by mini-css-extract-plugin
module.exports = {"paginator":"style__paginator__Y6bZq"};